var map = {
	"./alien_ldoge.svg": "2c96",
	"./circle_graph.svg": "be9a",
	"./comic_1.svg": "aca1",
	"./comic_2.svg": "1352",
	"./comic_3.svg": "5b21",
	"./comic_page.png": "ac55",
	"./creepy_ldoge.svg": "c6d3",
	"./hero.svg": "9dff",
	"./logo.png": "9d64",
	"./unicorn_ldoge.svg": "8d1c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";